import { AmlStatusEnum } from '@/api/amlbotAPI';

export const getStatusTranslationKey = (status: AmlStatusEnum) => {
  switch (status) {
    default:
      return 'translation.status_new';
    case AmlStatusEnum.NEW:
      return 'translation.status_new';
    case AmlStatusEnum.ERROR:
      return 'translation.status_error';
    case AmlStatusEnum.FAILED:
      return 'translation.status_failed';
    case AmlStatusEnum.PENDING:
      return 'translation.status_pending';
    case AmlStatusEnum.SUCCESS:
      return 'translation.status_success';
  }
};
